module.exports = __webpack_public_path__ + "img/monitoring-ship-selected.e63178d0.svg";